import { CheckCircleOutline, ErrorOutline, HourglassBottom } from '@mui/icons-material';
import { ListItemIcon, ListItemText, Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import {
  COMPLETE,
  FAILED,
  PENDING,
  POLLING,
  TIMEOUT,
  TIMEOUT_MESSAGE,
} from 'hooks/useRollingApiRequest/useRollingApiRequest.props';
import { STATUS } from 'services/hooks/useRolloverCompanies/rollover.types';
import { StatusListItemProps } from './StatusListItem.props';
import { classes, StyledListItem } from './StatusListItem.styles';

const StatusListItem = ({ item, index, idNameMap }: StatusListItemProps) => (
  <StyledListItem className={index % 2 !== 0 ? classes.selected : ''}>
    <ListItemText primary={idNameMap[item.key]} />
    <ListItemIcon>
      {item.state === TIMEOUT && (
        <Tooltip title={TIMEOUT_MESSAGE}>
          <HourglassBottom />
        </Tooltip>
      )}
      {[PENDING, POLLING].includes(item.state) && <CircularProgress size={24} />}
      {item.state === COMPLETE && <CheckCircleOutline color="primary" />}
      {item.state === FAILED && (
        <Tooltip title={item.errorMsg ?? ''} disableHoverListener={!item.errorMsg}>
          <ErrorOutline color="error" />
        </Tooltip>
      )}
      {item.state === STATUS.CONFLICT && (
        <Tooltip title={item.errorMsg ?? ''} disableHoverListener={!item.errorMsg}>
          <CheckCircleOutline />
        </Tooltip>
      )}
    </ListItemIcon>
  </StyledListItem>
);

export default StatusListItem;
